import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import { AppProvider } from "@/context/AppContext";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import CategoryProducts from "@/pages/CategoryProducts";
import ProductDetail from "@/pages/ProductDetail";
import Search from "@/pages/Search";
import Configurator from "@/pages/Configurator";
import PhotoRequest from "@/pages/PhotoRequest";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import ScanPage from "@/pages/ScanPage";
import Kontakt from "@/pages/Kontakt";
import Profile from "@/pages/Profile";
import PosLogin from "@/pages/pos/PosLogin";
import PosLayout from "@/pages/pos/PosLayout";
import Pos from "@/pages/pos/Pos";
import PosInvoices from "@/pages/pos/PosInvoices";
import PosReturns from "@/pages/pos/PosReturns";
import PosReport from "@/pages/pos/PosReport";
import PosProfile from "@/pages/pos/PosProfile";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* POS Routes — dedicated layout, outside main Layout */}
          <Route path="/arka/login" element={<PosLogin />} />
          <Route path="/arka" element={<PosLayout />}>
            <Route index element={<Pos />} />
            <Route path="fatura" element={<PosInvoices />} />
            <Route path="kthime" element={<PosReturns />} />
            <Route path="raport" element={<PosReport />} />
            <Route path="profili" element={<PosProfile />} />
          </Route>

          {/* Main site */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/kategori" element={<Categories />} />
                <Route path="/kategori/:slug" element={<CategoryProducts />} />
                <Route path="/produkt/:id" element={<ProductDetail />} />
                <Route path="/kerko" element={<Search />} />
                <Route path="/konfigurator" element={<Configurator />} />
                <Route path="/kerko-me-foto" element={<PhotoRequest />} />
                <Route path="/shporta" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/porosi-e-suksesshme/:orderNumber" element={<OrderSuccess />} />
                <Route path="/login" element={<Login />} />
                <Route path="/skano" element={<ScanPage />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/profili" element={<Profile />} />
                <Route path="/admin/*" element={<Admin />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
